import * as React from "react";
import { Box } from "@mui/material";
import { connect } from "react-redux";
import { loginSuper } from "../../app/store/actions/authActions";
import { Navigate } from "react-router-dom";
import { MainInput, MainPassword } from "../../app/components/Styles";
import { MarketingFormPage, MarketingButton } from "../../app/components/marketing";

export const SuperLogin = ({ loginSuper, user, token, isLoading }) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    loginSuper({
      email: data.get("email"),
      password: data.get("password"),
    });
  };

  if (user) {
    return <Navigate to={`/${token.split(" ")[0]}`} replace />;
  }

  return (
    <MarketingFormPage
      maxWidth="sm"
      title="Super admin"
      subtitle="Sign in with your credentials"
      loading={isLoading}
    >
      <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
        <MainInput
          margin="normal"
          required
          fullWidth
          id="email"
          label="Email"
          name="email"
          type="email"
          autoComplete="email"
          autoFocus
        />
        <MainPassword
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          type="password"
          id="password"
          autoComplete="current-password"
        />
        <MarketingButton type="submit" fullWidth sx={{ mt: 3, mb: 1 }}>
          Sign in
        </MarketingButton>
      </Box>
    </MarketingFormPage>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  isLoading: state?.auth?.isLoading,
  token: state?.auth?.token,
});

const mapDispatchToProps = { loginSuper };

export default connect(mapStateToProps, mapDispatchToProps)(SuperLogin);
